import React from "react";
import { Container } from "reactstrap";
import PageHero from "../../../components/Common/PageHero";
import { StripeConnectProvider } from "./StripeConnectContext";
import StripeStatusBanner from "./StripeStatusBanner";
import RentPayoutsSetup from "./RentPayoutsSetup";
import StripeBalancePayouts from "./StripeBalancePayouts";
import StripePayoutHistory from "./StripePayoutHistory";
import StripePayoutAccount from "./StripePayoutAccount";
import StripeDashboardButton from "./StripeDashboardButton";

/** Landlord/PM payout dashboard — Stripe Connect is the source of truth for
 * balances, payouts, and payout-account details. Porcher only stores the
 * association `users/{uid}.stripe.accountId`; no financial data is copied
 * into Firestore to render this page. */
const PaymentsPage = () => {
  document.title = "Payments | Support Portal";

  return (
    <div className="page-content">
      <Container fluid>
        <PageHero
          title="Payments"
          subtitle="Manage rent payouts and your connected payout account."
        />

        <StripeConnectProvider>
          <StripeStatusBanner />
          <RentPayoutsSetup />
          <StripeBalancePayouts />
          <StripePayoutHistory />
          <StripePayoutAccount />
          <StripeDashboardButton />
        </StripeConnectProvider>
      </Container>
    </div>
  );
};

export default PaymentsPage;

